namespace TabAurous.Inventory {
    export interface LocationTransferItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        DeptName?: string;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        CostMethodId?: number;
        DesignId?: number;
        DesignCode?: string;
        TaxCode?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        MetalId?: number;
        KaratId?: number;
        ProductSizeId?: number;
        AttributeId?: number;
        HSN?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        StockAllocation?: boolean;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        GroupId?: number;
        RoutingId?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        ExportPieces?: number;
        AckStatus?: number;
        CompanyId?: number;
        Purity?: number;
        PureWeight?: number;
        FancyCharges?: number;
        OtherCharges?: number;
        HasBom?: boolean;
        BOMDetails?: LocationTransferBOMRow[];
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        VoucherNo?: string;
        TransDate?: string;
        HUID?: string;
        StampId?: number;
        StoneRate?: number;
        OtherRate?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        IsPosted?: boolean;
        MFAmount?: number;
        MF?: number;
    }

    export namespace LocationTransferItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Inventory.LocationTransferItems';
        export const deletePermission = 'Inventory:LocationTransfer:Delete';
        export const insertPermission = 'Inventory:LocationTransfer:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:LocationTransfer:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            DeptName = "DeptName",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            CostMethodId = "CostMethodId",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            TaxCode = "TaxCode",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            MetalId = "MetalId",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            AttributeId = "AttributeId",
            HSN = "HSN",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            StockAllocation = "StockAllocation",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            GroupId = "GroupId",
            RoutingId = "RoutingId",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            ExportPieces = "ExportPieces",
            AckStatus = "AckStatus",
            CompanyId = "CompanyId",
            Purity = "Purity",
            PureWeight = "PureWeight",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            HasBom = "HasBom",
            BOMDetails = "BOMDetails",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            HUID = "HUID",
            StampId = "StampId",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            IsPosted = "IsPosted",
            MFAmount = "MFAmount",
            MF = "MF"
        }
    }
}
